// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveButton_root__35n47","light":"RemoveButton_light__1YIqa","dark":"RemoveButton_dark__BDfHA"};